// import style from './style.module.less';
import { Button, Row, Col } from 'antd';

import React from 'react';
import { inject, observer } from 'mobx-react';
import s from './style.module.less';

const error404 = () => {

    const goHome = () => {
        window.location.href = '/';
    };
    return (
        <>
            <div className={s.app}>
                <div className={s['app_logo']}></div>
                <div className={s.content}>
                    <h1></h1>
                    <div className={s.content_main}>
                        <Row style={{ margin: 'auto 0', padding: '160px' }} gutter="24">
                            <Col span={12} style={{ textAlign: 'right' }}>
                                <div className={s.empty}></div>
                            </Col>
                            <Col span={12} style={{ textAlign: 'left' }}>
                                <div style={{ textAlign: 'center', width: '240px', marginTop: '70px' }}>
                                    {/* <h3 style={{ color: 'red' }}>您暂无{this.props.store.login.userInfo.tenantName || '该租户'}的管理后台权限</h3> */}
                                    <h3 style={{ color: 'red' }}>您暂无此功能的管理权限</h3>
                                    <div
                                        style={{
                                            fontSize: '12px',
                                            color: '#999',
                                            margin: '14px 0  28px'
                                        }}
                                    >
                                        如果有需要请联系您的机构管理员
                                    </div>
                                    <Button type="primary" onClick={goHome} block>
                                        返回首页
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </>
    );
    // return (
    //     <div className={style['abnormal']}>
    //         <p className={style['text']}>404!</p>
    //         <p className={style['text']}>从前有座山！</p>
    //         <p className={style['text']}>山上有座庙！</p>
    //         <p className={style['text']}>庙里有个页面！</p>
    //         <p className={style['text']}>叫做找不到！</p>
    //     </div>
    // );
};
export default inject('store')(observer(error404));
